import { fade } from "@material-ui/core/styles";

export const useStyles = (theme) => ({
  search: {
    width: "100%",
    display: "flex",
    flexGrow: 1,
    position: "relative",
    marginRight: theme.spacing(50),
    marginLeft: 0,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      marginRight: 0,
      flexGrow: 0,
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "50%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  inputRoot: {
    height: 40,
    color: "#181818",
    backgroundColor: "#eee",
    borderRadius: 10,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "#eee !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "#eee !important",
    },
  },
});
